import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.StandaloneField', {
    standaloneFieldPlaceholder: 'Choose a value',
});
